import api from "../../../api/Api";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';

function Assign() {
  const { identy } = useParams();
  const [assign, setAssign] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setpageSize] = useState(8);
  const [sortField, setSortField] = useState("assignedDate");
  const [sortOrder, setSortOrder] = useState("desc");
  const [empName,setEmpName] = useState('');

  const fetchAssign = (page) => {
    if (!identy) return;
    api
      .post("/api/assignments/employee", {
        search: search && search.trim() !== "" ? search : null
      },
        {
          params: {
            identy: identy,
            page: page,
            size: pageSize,
            sort: `${sortField},${sortOrder}`,
          }
        }
      )
      .then((res) => {
        setEmpName(res.data.response)
        setAssign(res.data.response.assets.content);
        setTotalPages(res.data.response.assets.totalPages);
      })
      .catch(console.error);
  };


  useEffect(() => {
    fetchAssign(page);
  }, [identy, page, sortField, sortOrder, search]);

   useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setPage(0); 
      // fetchAssign(0);
    }, 100); 
    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handlePageChange = (event, value) => {
    setPage(value - 1);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  return (
    <div className="container-fluid mt-1 pt-2 d-flex flex-column" style={{height:'100%'}}>
      <div className='d-flex  align-items-center mb-3'>
        <Link to={`/assignments`} className="btn btn-secondary me-4 mt-3 mb-3">
          <ArrowBackIcon />
        </Link>
        <div className="d-flex gap-4">
        {/* <h2>{empName.employeeName}</h2> */}
        <h2>Assigned Assets</h2>
        </div>
        <input
          className="form-control rounded-pill p-3 ms-3 mt-2 mb-3"
          style={{ width: '60%', maxWidth: '600px', fontSize: '15px' }}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by asset name or type..."
        />

      </div>
      {/* <div className="text-center"><h2>{empName.employeeName}</h2></div> */}
      <div className="flex-grow-1">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-primary">
            <tr>
              <th style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}>#</th>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('asset.assetName')}>
                Asset {sortField === 'asset.assetName' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('asset.assetId')}>
                Asset ID {sortField === 'asset.assetId' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('asset.assetType')}>
                Type {sortField === 'asset.assetType' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('assignedDate')}>
                Assigned Date {sortField === 'assignedDate' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1 }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {assign.length > 0 ? (
              assign.map((a, index) => (
                  <tr key={a.assignIdenty}>
                    <td>{(page * pageSize) + index + 1}</td>
                    <td>{a.assetName}</td>
                    <td>{a.assetId}</td>
                    <td className="text-capitalize">{a.assetType}</td>
                    <td>{a.assignedDate}</td>
                    <td>
                     <div className="text-center">
                       <Link to={`/assignments/${a.assignIdenty}`} className="custom-btn me-2">
                        View
                      </Link>
                     </div>
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">No assignments found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-center mb-2">
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={page + 1}  // convert 0-based -> 1-based
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            variant="outlined"
          />
        </Stack>
      </div>
    </div>
  );
}

export default Assign;
